export enum ProductTaskCommentOriginEnum {
  NORMAL = 'normal',
  DEADLOCK_IN = 'deadlock_in',
  DEADLOCK_OUT = 'deadlock_out',
}
